module.exports = __webpack_public_path__ + "static/img/code2.780b928.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code2.jpg
// module id = auqI
// module chunks = 1